export enum SmartbannerTmsKey {
    LK_SMARTBANNER_OPEN = 'ouvrir_application',
    LK_SMARTBANNER_CLOSED = 'fermer_smartbanner',
    VW_SMARTBANNER = 'vue_smartbanner',
}
